/* eslint-disable import/order */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React, { useState } from 'react'
import styled from 'styled-components'
import { graphql } from 'gatsby'
import { motion } from 'framer-motion'

// Libraries
import parse from 'html-react-parser'

// Components
import SEO from 'components/SEO'
import Layout from 'components/shared/Layout'
import Requirements from 'components/Requirements'
import ParseContent from 'components/shared/ParseContent'
import Review from 'components/Review'
import PriceIndication from 'components/PriceIndication'
import Blog from 'components/Blog'
import RatingAlt from 'components/Reviews/RatingAlt'
import NationsSeeker from 'components/NationsSeeker'

// Elements
import HeroDefault from 'components/elements/HeroDefault'
import ImageBackground from 'components/elements/ImageBackground'
import HeroDescription from 'components/elements/HeroDescription'
import BlockDefault from 'components/elements/BlockDefault'
import ButtonDefault from 'components/elements/ButtonDefault'
import ButtonAnimateTruck from 'components/elements/ButtonAnimateTruck'
import BackgroundDescription from 'components/elements/BackgroundDescription'

// Data
import blogInfo from 'src/graphql/blogInfo'
import Infographic from '../components/Infopgrahic/Infographic'
import CTA from '../components/CTA'
import Arrow from 'img/icon/arrow-right-circled.inline.svg'
import FaqArrow from 'img/icon/arrow-right-circled-contrast.inline.svg'


const Intro = styled(BlockDefault)`
  @media (min-width: 992px) {
    margin-top: -150px;

    & h2 {
      font-size: ${(props) => props.theme.font.size.xl};
      font-weight: ${(props) => props.theme.font.weight.s};

      & strong {
        font-weight: ${(props) => props.theme.font.weight.xl};
      }
    }
  }

  @media (max-width: 991px) {
    margin-top: -100px;
  }
`

const FeaturedImage = styled(ImageBackground)`
  padding-top: 50%;
  border-radius: 35px;
  overflow: hidden;
`

const Block = styled(BlockDefault)`
  @media (min-width: 992px) {
    margin-top: -200px;
  }

  @media (max-width: 991px) {
    margin-top: -50px;
  }

  @media (max-width: 575px) {
    margin-top: -35px;
  }
`

const Content = styled(ParseContent)`
  & h1,
  & h2,
  & h3,
  & h4,
  & h5 {
    color: ${(props) => props.theme.color.text.contrast};
  }
`

export const pageQuery = graphql`
  query ($wordpress_id: Int) {
    page: wordpressPage(wordpress_id: { eq: $wordpress_id }) {
      path
      title
      wordpress_id

      acf {
        banner {
          title
          image {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 1920)
                openGraph: fluid(maxWidth: 1500, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }

        banner_block {
          title
          button {
            title
            url
          }
          button_info
          image_banner_block {
            localFile {
              childImageSharp {
                gatsbyImageData(width: 1920)
                openGraph: fluid(maxWidth: 1500, toFormat: JPG) {
                  src
                }
              }
            }
          }
        }

        content {
          intro
          link {
            title
            url
          }
        }

        usps {
          title
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          items {
            title
            description
          }
        }

        faq {
          title
          items {
            question
            answer
          }
        }

        search {
          title
          description
          background_description
          highlighted
          button {
              title
              url
          }
        }

        terms {
          title
          usp {
            relation
          }
        }

        intro {
          background_description
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          description
        }

        review {
          title
          rating
          description
          background_description
        }

        outro {
          image {
            localFile {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1000) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          description
          link {
            title
            url
          }
        }

        blog {
          related
          background_description
        }

        show_infographic
        show_cta
      }

      yoast_meta {
        name
        content
        property
      }
    }
  }
`

const PageTemplate = ({
  data: {
    page: { path, yoast_meta: yoast, acf, title, wordpress_id },
  },
}) => {

  const [indexOpen, setIndexOpen] = useState(null)
  const [faqActiveIndex, setFaqActiveIndex] = useState(0)

  const setOpen = index => {
    setIndexOpen(index === indexOpen ? null : index)
  }

  const toggleFaq = (index) => {
    setFaqActiveIndex(faqActiveIndex === index ? -1 : index)
  }
  
  return (
  <Layout>
    {acf &&
      acf.banner &&
      acf.banner.image &&
      acf.banner.image.localFile &&
      acf.banner.image.localFile.childImageSharp &&
      acf.banner.image.localFile.childImageSharp.openGraph &&
      acf.banner.image.localFile.childImageSharp.openGraph.src && (
        <SEO
          yoast={yoast}
          path={path}
          image={{
            url:
              acf.banner.image.localFile &&
              acf.banner.image.localFile.childImageSharp.openGraph.src,
          }}
        />
      )}

    {acf &&
      acf.banner_block &&
      acf.banner_block.image_banner_block &&
      acf.banner_block.image_banner_block.localFile &&
      acf.banner_block.image_banner_block.localFile.childImageSharp &&
      acf.banner_block.image_banner_block.localFile.childImageSharp.openGraph &&
      acf.banner_block.image_banner_block.localFile.childImageSharp.openGraph
        .src && (
        <SEO
          yoast={yoast}
          path={path}
          image={{
            url:
              acf.banner.image.localFile &&
              acf.banner.image.localFile.childImageSharp.openGraph.src,
          }}
        />
      )}


    <section>
      <HeroDefault
        small
        image={acf.banner.image || acf.banner_block.image_banner_block}
      >
        <HeroDescription className="d-flex align-items-center justify-content-start h-100">
          {parse(acf.banner.title)}
        </HeroDescription>
      </HeroDefault>
    </section>

    <section>
      <div className="container py-5">
        <div className="row">
          <div className="col-lg-1" />
          <div className="col-lg-10">
            <Intro bigBorderRadius>
              <div className="px-lg-4 py-lg-2">
                <div className="row">
                  <div className="col-md-6 d-flex align-items-center justify-content-center justify-content-lg-start">
                    {parse(acf.banner_block.title)}
                  </div>
                  <div className="col-md-6 text-center mt-4 mt-md-0 d-flex align-items-center justify-content-center justify-content-lg-end">
                    <div>
                      <RatingAlt noTitle className="pb-lg-0 pb-4" />
                      <div className="mt-4">
                        <ButtonAnimateTruck
                          to={acf.banner_block.button.url}
                          type="next"
                        >
                          {acf.banner_block.button.title}
                        </ButtonAnimateTruck>
                        <div className="mt-3">
                          {acf.banner_block.button_info}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Intro>
          </div>
        </div>
      </div>
    </section>
    
    {acf.search && acf.search.background_description && (
      <>  
      <section>
          <div className="container">
            <BackgroundDescription className="mt-lg-3" content={acf.search.background_description} />
          </div>
        </section>

        <section>
          <div className="container pt-lg-5 pt-0 mb-5 pt-lg-5">
            <NationsSeeker fields={acf.search} showAll hideButton />
          </div>
        </section>
      </>
    )}

    {acf.content && acf.content.intro && (
      <section>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-10">
              <Content content={acf.content.intro} />
              <ButtonDefault to={acf.content.link.url} className="mt-4">
                {acf.content.link.title}
              </ButtonDefault>
            </div>
          </div>
        </div>
      </section>
    )}

    {acf.usps && acf.usps.title && (
      <section>
        <div className="container py-5">
          <div className="row">
            <div className='col-lg-10'>
              <Content content={acf.usps.title} className="mb-5" />
            </div>

            <div className="col-lg-5">  
              {acf.usps.items.map(({ title, description }, index) => (
                <USP 
                  // eslint-disable-next-line react/no-array-index-key
                  key={index}
                  title={title} 
                  description={description} 
                  index={index}
                  setOpen={setOpen}
                  indexOpen={indexOpen}
                /> 
              ))}
            </div>
              <div className='col-lg-7'>
                <FeaturedImage src={acf.usps.image} className="h-100 object-fit-cover" />
              </div>
          </div>
        </div>
      </section>
    )}

    <section>
      <div className="container mt-lg-5">
        <BackgroundDescription
          className="mt-3"
          content={acf.intro.background_description}
          relative
        />

        <div className="row">
          <div className="col-lg-10">
            <FeaturedImage src={acf.intro.image} />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-5" />
          <div className="col-lg-7">
            <Block bigBorderRadius>
              <Content content={acf.intro.description} />
            </Block>
          </div>
        </div>
      </div>
    </section>

    <section>
      <div className="container mt-5 py-5">
        <div>{parse(acf.terms.title)}</div>
        <div className="mt-5">
          <Requirements ids={acf.terms.usp.map(({ relation }) => relation)} />
        </div>
      </div>
    </section>

    {acf.review && acf.review.title && (
      <section className="pt-5">
        <div className="container">
          <div className="row flex-wrap-reverse">
            <div className="col-lg-8">
              <BackgroundDescription
                className="mt-3"
                content={acf.review.background_description}
                relative
              />
            </div>
            <div className="col-lg-4">
              <PriceIndication noInfo />
            </div>
          </div>
        </div>
        <Review fields={acf.review} />
      </section>
    )}

    <section>
      <div className="container mt-lg-5 py-5">
        <div className="row">
          <div className="col-lg-2" />
          <div className="col-lg-10">
            <FeaturedImage src={acf.outro.image} />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-7">
            <Block bigBorderRadius>
              <Content content={acf.outro.description} />
              {acf.outro.link && acf.outro.link.title && acf.outro.link.url && (
                <ButtonDefault to={acf.outro.link.url} className="mt-4">
                  {acf.outro.link.title}
                </ButtonDefault>
              )}
            </Block>
          </div>
          <div className="col-lg-5" />
        </div>
      </div>
    </section>

    <section>
      <div className="container mb-lg-5 pb-5">
        <div className="row">
          <div className="col-lg-8" />
          <div className="col-lg-4">
            <RatingAlt noTitle className="pb-lg-0 pb-4" />
            <div className="mt-4">
              <PriceIndication />
            </div>
          </div>
        </div>
      </div>
    </section>

    {acf.blog && acf.blog.related && acf.blog.related.length > 0 && (
      <section>
        <div className="container mb-lg-5 pb-5">
          {acf.blog.background_description && (
            <BackgroundDescription
              content={acf.blog.background_description}
              relative
            />
          )}
          <Blog
            ids={acf.blog.related}
            fields={blogInfo.get()}
            hideMore
            hideFilters
          />
        </div>
      </section>
    )}

    {acf.show_infographic && <Infographic />}
    {acf.show_cta && <CTA/>}

    {acf.faq && acf.faq.title && (
      <section>
        <div className="container py-5">
          <div className="row">
            <div className="col-lg-10">
              <Content content={acf.faq.title} className="mb-5" />
              {acf.faq.items && acf.faq.items.length > 0 && (
                <BlockDefault bigBorderRadius>
                  {acf.faq.items.map((question, index) => {
                    const status = faqActiveIndex === index ? 'open' : 'closed'

                    return (
                      <FaqItem
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        className="mb-4"
                      >
                        {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                        <div
                          className="d-flex align-items-start justify-content-between"
                          onClick={() => toggleFaq(index)}
                          onKeyDown={(event) => {
                            if (event.key === 'Enter' || event.key === ' ') {
                              event.preventDefault()
                              toggleFaq(index)
                            }
                          }}
                          role="button"
                          tabIndex={0}
                          aria-expanded={status === 'open'}
                        >
                          
                          <h3 className='mr-3'>{question.question}</h3>
                          <motion.div
                            initial="open"
                            variants={{
                              open: { rotate: 90 },
                              closed: { rotate: 0 },
                            }}
                            animate={status}
                          >
                            <FaqIcon />
                          </motion.div>
                        </div>

                        <motion.div
                          initial="open"
                          variants={{
                            open: { opacity: 1, height: 'auto' },
                            closed: { opacity: 0, height: 0 },
                          }}
                          animate={status}
                          className="overflow-hidden"
                        >
                          <div className="mt-2">
                            <ParseContent content={question.answer} />
                          </div>
                        </motion.div>
                      </FaqItem>
                    )
                  })}
                </BlockDefault>
              )}
            </div>
          </div>
        </div>
      </section>
    )}
  </Layout>
)}

const StyledUSP = styled(BlockDefault)`
  background-color: ${props => props.theme.color.contrast};
  color: ${props => props.theme.color.text.light};
  border-radius: 25px;
  
  & h1, & h2, & h3 {
    font-weight: ${props => props.theme.font.weight.s};
    margin: 0;

    & strong, & b {
      font-weight: ${props => props.theme.font.weight.xl};
    }
  }

  @media (min-width: 992px) {
    padding: 25px 35px !important;
    max-width: 400px;
  }

  @media (max-width: 991px) {
    padding: 15px 25px !important;
    width: 100%;
  }
`

const Title = styled(motion.div)`
  &:hover {
    text-decoration: underline;
  }
`

const Icon = styled(Arrow)`
  height: 40px;
  width: 40px;
`

const FaqIcon = styled(FaqArrow)`
  height: 30px;
  width: 30px;
`

const FaqItem = styled.div`
  h3 {
    color: ${({ theme }) => theme.color.text.contrast};
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }
`

const Description = styled(motion.div)`
  overflow: hidden;
`

export const USP = ({ title, description, index, indexOpen, setOpen }) => {
  const status = indexOpen === index ? 'open' : 'closed'

  return (
    <StyledUSP className="mb-3">
      <Title
        role="button"
        className="d-flex justify-content-between align-items-center"
        onClick={() => {
          setOpen(index)
        }}
      >
        {parse(title)}
        <motion.div
          initial="open"
          variants={{
            open: { rotate: 90 },
            closed: { rotate: 0 },
          }}
          animate={status}
        >
          <Icon />
        </motion.div>
      </Title>
      <Description
        initial="open"
        variants={{
          open: { opacity: 1, height: 'auto' },
          closed: { opacity: 0, height: 0 },
        }}
        animate={status}
      >
        <div className="mt-3">
          <ParseContent content={description} />
        </div>
      </Description>
    </StyledUSP>
  )
}

export default PageTemplate
